import styled from 'styled-components';

export const OffCanvasContent = styled.div`
  display: grid;
  grid-template-rows: auto;
  height: 100%;
  width: 100%;
`;

export const OffCanvasContentData = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: white;
  border-radius: 10px;

  table {
    border: none;
    flex-grow: 1;
    max-height: 95%;
    overflow-y: auto;
    border-spacing: 0;
    border-collapse: collapse;
  }

  tbody {
    padding: 10px;
    display: block;
    max-height: 95%;
    overflow-y: auto;
  }

  tr {
    display: table;
    width: 100%;
  }

  td,
  th {
    text-align: start;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
`;

export const Th = styled.th`
  border-bottom: 0.25px solid #e8e9e9;
  padding: 8px;
  padding-left: 15px;
  width: 30%;
`;

export const Td = styled.td`
  border-bottom: 0.25px solid #e9e8e8;
  padding: 8px;
  padding-left: 15px;
  width: 70%;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

export const SeparadorTh = styled.th`
  background-color: #e2e2e2a9;
  padding: 0px;
  height: 1px;
  line-height: 1px;
  width: 30%;
`;

export const Separador = styled.td`
  background-color: #e2e2e2a9;
  padding: 0px;
  height: 10px;
  line-height: 1px;
  width: 70%;
`;

export const EmptyMessage = styled.p`
  text-align: center;
  margin: 20px 0;
  color: #6c757d;
`;
